webpackJsonp([213534597649335],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.928842f9.jpg";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic02.87b41c6b.jpg";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic03.0bd35de2.jpg";

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic04.12f40f57.jpg";

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic05.7f8f3b53.jpg";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic06.27e9e5b7.jpg";

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "AlphaCaptura"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Welcome to AlphaCaptura",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "a unique, robust, straightforward solution",
	                    _react2.default.createElement("br", null),
	                    " for ultra-low latency news trading and more."
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: "#one", className: "button next scrolly" },
	                            "Products"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(234);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _pic = __webpack_require__(137);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(138);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(139);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _pic7 = __webpack_require__(140);
	
	var _pic8 = _interopRequireDefault(_pic7);
	
	var _pic9 = __webpack_require__(141);
	
	var _pic10 = _interopRequireDefault(_pic9);
	
	var _pic11 = __webpack_require__(142);
	
	var _pic12 = _interopRequireDefault(_pic11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'index-site', content: siteDescription })
	            ),
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'two' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: '/acerca-de-nosotros' },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    'About us'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/acerca-de-nosotros', className: 'button next scrolly' },
	                                    'About us'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'one', className: 'tiles' },
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic12.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'AlphaCaputra API/UDP Feed'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The fastest way of getting reliable news, click her for a free trial'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/productos', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic6.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'AlphaCaptura Clicker'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'AC Clicker is made for point and click, super fast via Metatrader 4 (all rights reserved)'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/productos', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic4.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'CryptoCurrencies'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Machine Learning prediction feed / Buy and sell in big blocks'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/productos', className: 'link primary' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'three' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'About us'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/acerca-de-nosotros', className: 'button next' },
	                                    'About us'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'three' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Trading is risky'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'There is a substantial risk of loss in futures and forex trading. Online trading of stocks and options is extremely risky. Assume you will lose money. Don\'t trade with money you cannot afford to lose.'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-1061b2110fd6c3519be2.js